import { minutesToMs, type WalletWithTotalAmountDTO } from '@capsicum/common';
import { type QueryOptions, useQuery } from '@tanstack/react-query';

import { fetchUserWallet } from '../api/wallet';

import { useMainCurrenciesQuery } from './useMainCurrenciesQuery';

/**
 *
 * @param convertAmountToCurrencies
 * @returns user wallet
 */
export const useWalletQuery = <TData = undefined | WalletWithTotalAmountDTO>(
	select?: (data: undefined | WalletWithTotalAmountDTO) => TData,
	options?: QueryOptions
) => {
	const { data: currencies, error: currenciesQueryError } = useMainCurrenciesQuery();

	if (currenciesQueryError) throw currenciesQueryError;

	const { convertAmountToCurrencies } = currencies ?? {};

	return useQuery({
		enabled: Boolean(convertAmountToCurrencies?.length),
		gcTime: minutesToMs(3),
		queryFn: () =>
			fetchUserWallet({
				'convertAmountToCurrencies[]': convertAmountToCurrencies,
				'details[]': ['onlyCurrentMainNetwork']
			}),
		queryKey: ['wallet', { convertAmountToCurrencies }],
		refetchInterval: minutesToMs(2),
		select: select as ((data: unknown | WalletWithTotalAmountDTO) => TData) | undefined,
		staleTime: minutesToMs(2),
		...options
	});
};
